import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

export const MaxWidth = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  width: 100%;
`;

export const HeaderBackground = styled.div`
  background-color: ${p => p.theme.token('background-active')};
  border-top: 1px solid ${p => p.theme.token('border-color-default')};
  margin-bottom: ${primitive.$spacing2};
`;

export const HeaderWrapper = styled.div`
  color: ${p => p.theme.token('text-reversed')};

  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const Header = styled.h1`
  font: ${brandFont.headerOne};
`;

export const MaxWidthFullHeight = styled(MaxWidth)`
  height: 100%;
`;

export const ToggleViewButtonWrapper = styled.div`
  position: absolute;
  right: ${primitive.$spacing2};
`;

export const ServiceModeCategoryToggleWrapper = styled.div`
  padding: ${primitive.$spacing2} ${primitive.$spacing4};

  display: flex;
  justify-content: center;

  background-color: ${p => p.theme.token('background-default')};

  fieldset {
    margin: 0;
  }

  legend {
    display: none;
  }

  ${Styles.mobile`
    width: 100%;
  `}
`;

export const SearchBarWrapper = styled.div`
  background-color: ${p => p.theme.token('background-default')};
  padding: ${primitive.$spacing2} ${primitive.$spacing4};
  width: 100%;
  height: 80px;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  ${Styles.desktop`
    flex-direction: row;
  `}
`;

export const SearchContainer = styled(FlexContainer)`
  padding-bottom: ${primitive.$spacing2};
`;
